import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute(
  '/auswahlfelder/antragsarten-genehmigungstypen/',
)({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="RequestTypeApprovalType"
      returnRoute="/auswahlfelder/requestTypeApprovalType"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const RequestTypeApprovalTypeRoute = Route;
